import { PropsWithChildren, useEffect, useRef, useState } from "react";

import { Flex } from "antd";
import style from "./VisibilityAnimator.module.scss";

interface VisibilityAnimatorProps extends PropsWithChildren {
  isVisible: boolean;
  initialVisibility: boolean;
  preventAnimation?: boolean;
}

const VisibilityAnimator = ({
  initialVisibility,
  isVisible,
  children,
  preventAnimation,
}: VisibilityAnimatorProps) => {
  const [showElement, setShowElement] = useState<boolean>(initialVisibility);
  const animatorRef = useRef<HTMLElement>(null);

  const addShowAnimation = () => {
    animatorRef.current?.classList.remove(style.hideAnimation);
    animatorRef.current?.classList.add(style.showAnimation);
  };

  const addHideAnimation = () => {
    animatorRef.current?.classList.remove(style.showAnimation);
    animatorRef.current?.classList.add(style.hideAnimation);
  };

  useEffect(() => {
    if (preventAnimation) {
      setShowElement(isVisible);
      return;
    }

    if (isVisible) {
      addShowAnimation();
    } else {
      addHideAnimation();
    }

    setTimeout(() => {
      setShowElement(isVisible);
    }, 100);
  }, [isVisible, preventAnimation]);

  return showElement ? (
    <Flex
      {...(preventAnimation
        ? {}
        : {
            className: !initialVisibility ? style.showAnimation : "",
            ref: animatorRef,
          })}
    >
      {children}
    </Flex>
  ) : (
    <></>
  );
};

export default VisibilityAnimator;
